/* =========================================================
   THE BOO CREW — Hero scroll cue + story modal + ticker + reveal
   Re-skin of the Black Jar landing JS, fully namespaced under
   `boo` so it can coexist with the Black Jar sections on the
   same store with zero collision.

   Loaded from more than one section (hero, modal), so it guards
   against running its setup twice on the same page.

   Story modal: delegated on document so it works no matter how
   many section-boo-crew instances (or fragrance blocks) exist.
   Each card's detail content lives in a <template> next to it;
   this script only ever reads it at click time — nothing here is
   hard-coded, so the popup always reflects whatever the merchant
   configured for that specific block.
   ========================================================= */
(function () {
  'use strict';

  if (window.booLandingJsLoaded) return;
  window.booLandingJsLoaded = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero: scroll cue jumps to the next section down ----
     Shopify wraps every JSON-template section in its own
     .shopify-section div, so the sections themselves are never
     siblings — their wrapper divs are. Walk up to that wrapper
     first, or the sibling lookup silently finds nothing. */
  var scrollTriggers = document.querySelectorAll('[data-boo-scroll-next]');
  scrollTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var current = trigger.closest('.shopify-section') || trigger.closest('section');
      var next = current ? current.nextElementSibling : null;
      if (!next) return;
      next.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });

  /* ---- Callout ticker ----
     The run is cloned until the track is at least twice the viewport,
     so the -50% keyframe always lands on an identical frame and the
     loop has no seam. Duration is paced off the measured run width so
     a long strip and a short one travel at the same speed. */
  var PIXELS_PER_SECOND = 55;

  function buildTicker(track) {
    var sourceRun = track.firstElementChild;
    if (!sourceRun) return;

    // Back to a single run before re-measuring, or repeated resizes
    // stack clones on top of clones.
    while (track.children.length > 1) {
      track.lastElementChild.remove();
    }

    var runWidth = sourceRun.offsetWidth;
    if (!runWidth) return;

    var copies = Math.max(1, Math.ceil(window.innerWidth / runWidth));
    var frag = document.createDocumentFragment();
    for (var i = 0; i < copies * 2 - 1; i++) {
      var clone = sourceRun.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      frag.appendChild(clone);
    }
    track.appendChild(frag);

    track.style.animationDuration = (runWidth * copies) / PIXELS_PER_SECOND + 's';
  }

  var tickerTracks = document.querySelectorAll('[data-boo-ticker-track]');
  if (tickerTracks.length && !prefersReducedMotion) {
    tickerTracks.forEach(buildTicker);
    window.addEventListener('load', function () {
      tickerTracks.forEach(buildTicker);
    });
    var tickerTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(tickerTimer);
      tickerTimer = setTimeout(function () {
        tickerTracks.forEach(buildTicker);
      }, 200);
    });
  }

  /* ---- Reveal cards on scroll ---- */
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('boo-in-view');
          reveal.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.boo-card').forEach(function (c, i) {
      c.style.transitionDelay = (i % 3) * 70 + 'ms';
      reveal.observe(c);
    });
  } else {
    document.querySelectorAll('.boo-card').forEach(function (c) {
      c.classList.add('boo-in-view');
    });
  }

  /* ---- Story modal ---- */
  var backdrop = document.getElementById('booModalBackdrop');
  if (!backdrop) return;

  var modal = backdrop.querySelector('.boo-modal');
  var closeBtn = document.getElementById('booModalClose');
  var imageEl = document.getElementById('booModalImage');
  var familyEl = document.getElementById('booModalFamily');
  var nameEl = document.getElementById('booModalName');
  var detailEl = document.getElementById('booModalDetail');
  var lastFocused = null;

  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function openModal(trigger) {
    var targetId = trigger.getAttribute('data-boo-target');
    var source = targetId ? document.getElementById(targetId) : null;
    if (!source) return;

    familyEl.textContent = source.dataset.family || '';
    nameEl.textContent = source.dataset.name || '';

    imageEl.removeAttribute('src');
    imageEl.alt = '';
    if (source.dataset.image) {
      imageEl.src = source.dataset.image;
      imageEl.alt = source.dataset.imageAlt || '';
    }

    detailEl.replaceChildren();
    var content = 'content' in source ? source.content : source;
    detailEl.appendChild(content.cloneNode(true));

    lastFocused = trigger;
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-boo-card-trigger]');
    if (trigger) {
      openModal(trigger);
    }
  });

  closeBtn.addEventListener('click', closeModal);

  backdrop.addEventListener('click', function (event) {
    if (event.target === backdrop) closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (!backdrop.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      var items = modal.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
